import React from 'react';
import { ThumbsUp, UserCheck, Smile } from 'lucide-react';
import feature from "../Assets/featurte-image.png"

export default function TravelLandingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-orange-50 to-amber-100 relative overflow-hidden">
      {/* Decorative pattern overlay */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23d97706' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
      }}></div>

      <div className="container mx-auto px-4 py-12 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-12">
            {/* Header */}
            <div className="space-y-4">
              <h1 className="text-6xl font-bold text-gray-900 leading-tight">
                Where Journeys <br />
                <span className="text-orange-500">Feel</span> Like <span className="text-orange-500">Home</span>
              </h1>
              <p className="text-lg text-gray-700 max-w-xl">
                Experience ultimate comfort and pure joy on every trip, transforming your journey into something far beyond just travel.
              </p>
            </div>

            {/* Features */}
            <div className="space-y-8">
              {/* Experience & Trust */}
              <div className="flex items-center gap-6">
                <div className="w-24 h-24 rounded-full border-4 border-orange-400 bg-white flex items-center justify-center flex-shrink-0">
                  <ThumbsUp className="w-10 h-10 text-gray-700" strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-semibold text-gray-900">Experience & Trust</h3>
              </div>

              {/* Customer Satisfaction */}
              <div className="flex items-center gap-6 ml-32">
                <div className="w-24 h-24 rounded-full border-4 border-orange-400 bg-white flex items-center justify-center flex-shrink-0">
                  <UserCheck className="w-10 h-10 text-gray-700" strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-semibold text-gray-900">Customer Satisfaction</h3>
              </div>

              {/* Happy Customer */}
              <div className="flex items-center gap-6">
                <div className="w-24 h-24 rounded-full border-4 border-orange-400 bg-white flex items-center justify-center flex-shrink-0">
                  <Smile className="w-10 h-10 text-gray-700" strokeWidth={1.5} />
                </div>
                <h3 className="text-2xl font-semibold text-gray-900">Happy Customer</h3>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src={feature}
                alt="Charminar Monument"
                className="w-full h-auto object-cover"
              />
              {/* Gradient overlay for better integration */}
              <div className="absolute inset-0 bg-gradient-to-l from-transparent via-transparent to-amber-100/20"></div>
            </div>
            
            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-32 h-32 bg-orange-400/20 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-8 -left-8 w-40 h-40 bg-amber-400/20 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </div>
  );
}